import styled from 'styled-components/native'
import newnote from '../../lib/assets/icons/new-note.svg'
import schedule from '../../lib/assets/icons/schedulePatients.svg'
import refresh from '../../lib/assets/icons/refresh-icon.svg'

import reactStyled from 'styled-components'
import { Constants } from '@sukiai/components'

const { Z_INDEX, ICON_SIZE } = Constants

export const ToolBarContainer = styled.View`
  height: 54px;
  min-width: 20%;
  position: fixed;
  right: 75px;
  top: 14px;
  z-index: ${Z_INDEX.VEIL_ACTIVE - 1};
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  margin-top: ${props => props.marginTop ? props.marginTop : '0px'};
`

export const ScheduleIcon = reactStyled.img.attrs({
  src: schedule
})`
  height: ${ICON_SIZE.SMALL}px;
  width: ${ICON_SIZE.SMALL}px;
  z-index: ${Z_INDEX.VEIL_ACTIVE};
`

export const RefreshIcon = reactStyled.img.attrs({
  src: refresh
})`
  height: ${ICON_SIZE.SMALL}px;
  width: ${ICON_SIZE.SMALL}px;
  z-index: ${Z_INDEX.VEIL_ACTIVE};
`

export const NewNoteIcon = reactStyled.img.attrs({
  src: newnote
})`
  height: ${ICON_SIZE.SMALL}px;
  width: ${ICON_SIZE.SMALL}px;
  z-index: ${Z_INDEX.VEIL_ACTIVE};
`

export const Container = styled.TouchableOpacity`
  z-index: ${Z_INDEX.VEIL_ACTIVE};
  padding-right: 30px;
  opacity: ${props => props.disabled ? 0.25 : 1};
  top: 11px;
`
